import { render } from "./armazemForm.vue?vue&type=template&id=08362d8c&scoped=true"
import script from "./armazemForm.vue?vue&type=script&lang=js"
export * from "./armazemForm.vue?vue&type=script&lang=js"

import "./armazemForm.vue?vue&type=style&index=0&id=08362d8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08362d8c"]])

export default __exports__